// trim-form-values.service.ts
import { Injectable } from '@angular/core';
import { AbstractControl } from '@angular/forms';

@Injectable({
  providedIn: 'root'
})
export class TrimFormValuesService {
  constructor() { }
  trimValues(data: { [key: string]: any } | { [key: string]: AbstractControl }): void {
    Object.keys(data).forEach(key => {
      const value = data[key];
      if (typeof value === 'string') {
        data[key] = value.trim();
      } else if (value instanceof AbstractControl && value.value && typeof value.value === 'string') {
        value.setValue(value.value.trim());
      }
    });
  }

}
